import { SButton, SButtonContainer, SCheckbox, SDialogButton, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableContainer } from '@material-ui/core';
import { HeadCell, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import { CooperativaDTO, UserDTO } from '../common/Dtos';
import AuthContext from '../auth/AuthContext';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { RiAddFill } from 'react-icons/ri';
import { FaTrash } from 'react-icons/all';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import { AlertDialogContext } from '../common/AlertDialog';

export function Cooperative() {
	const auth = useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const history = useHistory();
	const [cooperativeList, setCooperativeList] = useState<CooperativaDTO[]>([])
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const [role, setRole] = useState<string>('');
	const [cooperativa, setCooperativa] = useState<CooperativaDTO>();
	const [selected, setSelected] = useState<string[]>([]);
	const [totalRow, setTotalRow] = useState(0);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [deleteModalMessage, setDeleteModalMessage] = useState('');

	const headCells: HeadCell[] = [
		{id: 'name', numeric: false, disablePadding: false, label: 'NOME', sortable: false},
		{id: 'supervisor', numeric: false, disablePadding: true, label: '', sortable: false},
		{id: 'responsible', numeric: false, disablePadding: true, label: '', sortable: false},
		{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
	];

	useEffect(() => {
		getAll();
	}, []);


	const getAll = () => {
		auth.state.axiosInstance?.get('/api/cooperativa/listall')
			.then(res => {
				setCooperativeList(res.data)
				setTotalRow(res.data.length);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	}

	const handleNewCooperativa = () => {
		history.push("/dettaglio/cooperativa");
	};

	const handleDettaglioClick = (coop: CooperativaDTO) => {
		history.push("/dettaglio/cooperativa/" + coop.id);
	};

	const handleModalOpen = (cooperativa: CooperativaDTO, role: string) => {
		setCooperativa(cooperativa);
		setRole(role);
		setModalOpen(true);
	}

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = cooperativeList.map((n) => n.id);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleCheckBoxClick = (event: React.MouseEvent<unknown>, id: string) => {
		const selectedIndex = selected.indexOf(id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const isSelected = (name: string) => selected.indexOf(name) !== -1;

	const handleEliminaSelezionati = () => {
		setDeleteModalMessage('Sei sicuro di voler procedere con la cancellazione?');
		if (selected.findIndex((id) => id === auth.state.cooperativa) !== -1) {
			setDeleteModalMessage('E\' stata selezionata la Cooperativa di appartenenza, questa non verra\' eliminata. \n Sei sicuro di voler procedere con la cancellazione?');
		}
		setDeleteModalVisible(true);
	}

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const confirmDeleteModal = () => {
		setDeleteModalVisible(false);
		var ids = '';
		selected.filter(id => id !== auth.state.id).forEach(id => ids += id + ',');
		ids = ids.substr(0, ids.length - 1);
		auth.state.axiosInstance?.delete('/api/cooperativa/deleteAllById/' + ids)
			.then(res => {
				getAll();
				toast.success('Cooperative eliminate con successo!');
			})
			.catch(error => {
				if (406 === error.response.status) {
					alert.setAlertMessage(error.response.data.message);
					alert.setShowAlert(true);
				} else {
					toast.error('🛑 Errore durante la cancellazione delle Cooperative!');
				}
				console.log(error);
			});
	};

	return (
		<div>
			<STitleContainer>
				<STitleH3>Cooperative</STitleH3>
			</STitleContainer>
			<SButtonContainer>
				<SButton onClick={handleNewCooperativa}><RiAddFill className="mr-2"/>Aggiungi</SButton>
				<SButton onClick={handleEliminaSelezionati} variant="rosso"
								 disabled={!selected ||
								 selected.length === 0 ||
								 (selected.length === 1 && selected.findIndex((id) => id === auth.state.id) !== -1)}><FaTrash className="mr-2"/>Elimina</SButton>
			</SButtonContainer>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">
						<STableHeader
							numSelected={selected.length}
							onSelectAllClick={handleSelectAllClick}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={false}
							disableAction={false}
						/>
						<TableBody>
							{cooperativeList &&
							cooperativeList.map((row, index) => {
								const isItemSelected = isSelected(row.id);
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<STableRow
										hover
										tabIndex={-1}
										key={row.id}
									>
										<STableCell padding="checkbox">
											<SCheckbox
												checked={isItemSelected}
												inputProps={{'aria-labelledby': labelId}}
												onClick={(event) => handleCheckBoxClick(event, row.id)}
											/>
										</STableCell>
										<STableCell padding="default">{row.name}</STableCell>
										<STableCell padding="none">
											<SDialogButton className="w-50"
																		 onClick={() => handleModalOpen(row, 'Supervisori')}>Visualizza
												Supervisori</SDialogButton>
										</STableCell>
										<STableCell padding="none">
											<SDialogButton className="w-50"
																		 onClick={() => handleModalOpen(row, 'Responsabili')}>Visualizza
												Referenti</SDialogButton>
										</STableCell>
										<STableCell padding="none" className="text-center">
											<SDialogButton className="w-50"
																		 onClick={() => handleDettaglioClick(row)}>Dettaglio</SDialogButton>
										</STableCell>
									</STableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
			<ConfirmAlertDialog
				open={deleteModalVisible}
				onCancel={closeDeleteModal}
				onConfirm={confirmDeleteModal}
				message={deleteModalMessage}
			/>
			<DialogSupervisoriResponsabili open={modalOpen} role={role} cooperativa={cooperativa as CooperativaDTO} onClose={setModalOpen}/>
		</div>
	)
}


export interface DialogSupervisoriResposabiliProps {
	open: boolean;
	role: string;
	cooperativa: CooperativaDTO;
	onClose: (handleClose: boolean) => void;
}

function DialogSupervisoriResponsabili(props: DialogSupervisoriResposabiliProps) {
	const auth = React.useContext(AuthContext);
	const [responsabiliSupervisoriList, setResponsabiliSupervisoriList] = useState<UserDTO[]>([]);
	const headCells: HeadCell[] = [
		{id: 'name', numeric: false, disablePadding: false, label: 'NOME', sortable: true},
		{id: 'cognome', numeric: false, disablePadding: true, label: 'COGNOME', sortable: true},
	];


	useEffect(() => {
		if (props?.role === 'Supervisori') {
			setResponsabiliSupervisoriList([]);
			auth.state.axiosInstance?.get('/api/cooperativa/get_supervisori_of_cooperativa/' + props?.cooperativa?.id)
				.then(res => {
					setResponsabiliSupervisoriList(res.data);
					// setFilteredPrestazioniConfigAllList(res2?.data);
				}).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Supervisori della Cooperativa!');
				console.log(error);
			});
		} else if (props?.role === 'Responsabili') {
			setResponsabiliSupervisoriList([]);
			auth.state.axiosInstance?.get('/api/cooperativa/get_responsabili_of_coperativa/' + props?.cooperativa?.id)
				.then(res => {
					setResponsabiliSupervisoriList(res.data);
					// setFilteredPrestazioniConfigAllList(res2?.data);
				}).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Responsabili della Cooperativa');
				console.log(error);
			});
		}
	}, [props?.cooperativa?.id, props?.role])

	return (
		<Dialog open={props.open} disableBackdropClick maxWidth={"lg"} fullWidth>
			<DialogTitle>Lista {props.role}</DialogTitle>
			<DialogContent>
				<Paper>
					<TableContainer>
						<Table
							aria-labelledby="tableTitle"
							size={'medium'}
							aria-label="enhanced table">
							<STableHeader
								numSelected={0}
								rowCount={0}
								headCells={headCells}
								addCheckbox={false}
								bgcolor="primary"
								sortable={false}
								disableAction={false}
							/>
							<TableBody>
								{responsabiliSupervisoriList &&
								responsabiliSupervisoriList.map((row, index) => {
									return (
										<STableRow hover tabIndex={-1} key={row?.id}>
											<STableCell padding="default">{row?.firstname}</STableCell>
											<STableCell padding="default">{row?.lastname}</STableCell>
										</STableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</Paper>
				<div className="w-100 d-flex justify-content-end align-items-center my-3">
					<SDialogButton className="w-20" onClick={() => props.onClose(false)}>Chiudi</SDialogButton>
				</div>
			</DialogContent>
		</Dialog>
	)
}
